import React, { useEffect, useState } from "react";
import { FiEdit2, FiPlus, FiTrash2, FiX, FiSave } from "react-icons/fi";
import { supabase } from "../supabaseClient";

function AboutTwo() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(null);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");

  useEffect(() => {
    const getItems = async () => {
      const res = await supabase.from("AboutTwo").select("*");
      setItems(res.data);
    };
    getItems();
  }, []);

  const openCreate = () => {
    setTitle("");
    setDesc("");
    setModal({ mode: "create" });
  };

  const openEdit = (item) => {
    setTitle(item.title);
    setDesc(item.description);
    setModal({ mode: "edit", id: item.id });
  };

  const saveItem = async () => {
    if (!title.trim()) return;
    if (modal.mode === "create") {
      const res = await supabase
        .from("AboutTwo")
        .insert([{ title: title.trim(), description: desc.trim() }])
        .select();
      setItems((prev) => [...prev, res.data[0]]);
    } else {
      await supabase
        .from("AboutTwo")
        .update({ title: title.trim(), description: desc.trim() })
        .eq("id", modal.id);
      setItems((prev) =>
        prev.map((it) =>
          it.id === modal.id ? { ...it, title: title.trim(), description: desc.trim() } : it
        )
      );
    }
    setModal(null);
  };

  const deleteItem = async (id) => {
    await supabase.from("AboutTwo").delete().eq("id", id);
    setItems((prev) => prev.filter((it) => it.id !== id));
  };

  return (
    <section className="about-card">
      <div className="about-card__head">
        <h2 className="about-card__title">Parent Safety Features</h2>
        <button type="button" className="about-btn" onClick={openCreate}>
          <FiPlus aria-hidden />
          Add Feature
        </button>
      </div>
      <ul className="about-list">
        {items.map((item) => (
          <li key={item.id} className="about-list__item">
            <span className="about-list__check" aria-hidden>✓</span>
            <div className="about-list__text">
              <h3 className="about-list__title">{item.title}</h3>
              <p className="about-list__desc">{item.description}</p>
            </div>
            <div className="about-icon-actions">
              <button
                type="button"
                className="about-icon-btn about-icon-btn--edit"
                aria-label={`Edit ${item.title}`}
                onClick={() => openEdit(item)}
              >
                <FiEdit2 />
              </button>
              <button
                type="button"
                className="about-icon-btn about-icon-btn--del"
                aria-label={`Delete ${item.title}`}
                onClick={() => deleteItem(item.id)}
              >
                <FiTrash2 />
              </button>
            </div>
          </li>
        ))}
      </ul>

      {modal && (
        <div className="faqs-modal-backdrop" role="presentation" onClick={() => setModal(null)}>
          <div className="faqs-modal" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
            <div className="faqs-modal__head">
              <h2 className="faqs-modal__title">{modal.mode === "create" ? "Add Safety Feature" : "Edit Safety Feature"}</h2>
              <button type="button" className="faqs-icon-btn" onClick={() => setModal(null)} aria-label="Close">
                <FiX />
              </button>
            </div>
            <div className="faqs-modal__form">
              <label className="faqs-field">
                <span className="faqs-field__label">Title</span>
                <input className="faqs-field__input" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Feature title" autoFocus />
              </label>
              <label className="faqs-field">
                <span className="faqs-field__label">Description</span>
                <textarea className="faqs-field__textarea" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Feature description" rows={3} />
              </label>
              <div className="faqs-modal__foot">
                <button type="button" className="faqs-btn faqs-btn--outline" onClick={() => setModal(null)}>Cancel</button>
                <button type="button" className="faqs-btn faqs-btn--primary" onClick={saveItem}>
                  <FiSave aria-hidden /> Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default AboutTwo;